module.exports = __webpack_public_path__ + "assets/music/epic/It All Ends Here by Moonthief.ogg";